import TestUserAgent from './TestUserAgent';
const autoplayPermissionMap = {
    denied: {
        regExp: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i,
        browsersRegExp: /Safari|Chrome/i
    }
};

export const permission = TestUserAgent(autoplayPermissionMap);
export const isAllowed = permission !== 'denied';
